<template>
    <div class="layout-left stream">
        <el-scrollbar>
            <el-menu
                :default-active="navMenuDefault"
                class="el-menu-vertical-demo"
                :collapse="isCollapse"
                router
                unique-opened
                @select="handleNavMenuClick"
            >
                <div
                    v-for="(item, index) in navMenus"
                    :key="index"
                >
                    <div v-if="!item.childs">
                        <el-menu-item :index="item.entity.path">
                            <i
                                class="iconfont "
                                :class="item.entity.icon"
                            />
                            <span slot="title">{{ item.entity.alias }}</span>
                        </el-menu-item>
                    </div>
                    <div v-else>
                        <el-submenu
                            :key="item.entity.id"
                            :class="{'is-show-down':isCollapse}"
                            :index="item.entity.alias"
                        >
                            <el-menu-item
                                v-for="(item2, index2) in item.childs"
                                :key="index2"
                                :index="item2.entity.path"
                            >
                                <span slot="title">{{ item2.entity.alias }}</span>
                            </el-menu-item>
                            <template slot="title">
                                <i
                                    class="iconfont "
                                    :class="item.entity.icon"
                                />
                                <span
                                    v-show="!isCollapse"
                                    slot="title"
                                >{{ item.entity.alias }}</span>
                            </template>
                        </el-submenu>
                    </div>
                </div>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
</style>

<style scoped >
.el-scrollbar {
    left: 0;
    top: 45px;
    bottom: -15px;
    position: fixed;
    z-index: 99;
}
.el-scrollbar__wrap {
    overflow: scroll;
    overflow-x: auto;
}
.is-show-down /deep/ .el-icon-arrow-right {
    display: none;
}
.layout-left >>> .el-scrollbar__view,
.el-scrollbar__view,
.el-menu--collapse,
.el-menu-vertical-demo {
    border: 0;
    min-height: 100%;
}
.layout-left >>> .el-scrollbar__view {
    border-right: 1px solid #eee;
    background: #fff;
}
.layout-left .iconfont {
    margin-right: 8px;
}
</style>

<script>
import navMenus from '@/utils/vueMenus'

export default {
    data () {
        return {
            navMenus
        }

    },
    computed: {
        navMenuDefault () {
            return this.$store.state.NavMenuActive
        },
        isCollapse () {
            return this.$store.state.Layout.isCollapse;
        }
    },
    methods: {
        // 选中的tab
        handleNavMenuClick () {
            // let arr = key.split('-');
            // arr.forEach()
        }
    }
}
</script>